import { Type } from "~/models/dto";

const COMPONENT_TYPE_KEY = "Type";
const HEALTH_STATE_KEY = "HealthState";

const IDENTIFIER_TYPE = "identifier";

export const advancedFilterNames: Array<string> = [
	Type.Domain.toLowerCase(),
	Type.Layer.toLowerCase(),
	HEALTH_STATE_KEY.toLowerCase(),
	Type.Label.toLowerCase(),
	COMPONENT_TYPE_KEY.toLowerCase(),
	"id",
];

export const allFilterNames: Array<string> = [...advancedFilterNames, IDENTIFIER_TYPE];
